// 予め定義されたジム情報
// いずれはこれもユーザー自身で設定してlocalstoregeに保存できるといいかもしれない
const places = [
  // CERO
  {
    name : 'CERO 2F',
    category : [
      {
        name : '壁',
        params: ['①', '②', '③', '④', '⑤', '⑥', 'まぶし', '他'],
        vw: 25, // 1/4
        value: ''
      },
      {
        name : 'グレード',
        // Vuetifyマテリアルカラーパレットのlighten-3を使用
        params: ['茶(4級)',  '茶(3級)',  '黄緑(2級)', '黄緑(1級)', '週課題',    '他'],
        color:  ['#BCAAA4', '#BCAAA4', '#A5D6A7', '#A5D6A7', '#FFCC80', '#EEEEEE'],
        vw: 25,
        value: ''
      },
      {
        name : '課題',
        params: ['□', 'Ⅱ', '|', 'V', 'T', '✕', '↑', '他'],
        vw: 12.5, // 8
        // vw: 16.6666, // 6
        // vw: 14.2857, // 7
        // vw: 20,
        value: ''
      },
      {
        name : 'リザルト',
        params: ['完登', 'バラし', '落ち'],
        vw: 33.3333,
        value: ''
      },
      {
        name : 'コメント',
        params: [],
        vw: 100,
        value: ''
      }
    ]
  },
  // CERO 2F α
  {
    name : 'CERO 2F α',
    category : [
      {
        name : '4級', // 茶色 #BCAAA4
        params: [
          '①-黃', '①-緑',
          '②-オレンジ', '②-ピンク',
          '③-青', '③-オレンジ',
          '④-赤', '④-青',
          '⑤-緑', '⑤-赤青',
          '⑥-黃'
        ],
        vw: 50, // 1/2
        value: ''
      },
      {
        name : '3級',
        params: ['①-黒ピンク', '②-緑', '③-黒', '④-黒紫', '⑤-黒緑', '⑥-オレンジ'],
        color:  [],
        vw: 100,
        value: ''
      },
      {
        name : '2級',
        params: ['①-紫', '①-赤', '②-木ボテ', '②-青', '③-白紫', '③-赤黄', '④-黒緑', '⑤-白紫', '⑥-赤', '⑥-黒'],
        color:  [],
        vw: 100,
        value: ''
      },
      {
        name : '1級',
        params: ['①-黒黄', '②-黄', '③-黄', '④-青黄', '⑤-黄'],
        color:  [],
        vw: 100,
        value: ''
      },
      {
        name : 'リザルト',
        params: ['完登', 'バラし', '落ち'],
        vw: 33.3333,
        value: ''
      },
      {
        name : 'コメント',
        params: [],
        vw: 100,
        value: ''
      }
    ]
  },
  // CERO(リード)
  {
    name : 'CERO(リード)',
    category : [
      {
        name : '壁',
        params: ['柱表', '柱裏', '奥左', 'ルーフ'],
        vw: 25,
        value: ''
      },
      {
        name : 'グレード',
        params: ['~10d', '11a', '11a/b', '11b', '11b/c', '11c', '11c/d', '11d', '12a', '12a/b', '12b', '12b/c'],
        vw: 16.6666,
        value: ''
      },
      {
        name : '課題',
        params: ['□', 'Ⅱ', '|', 'V', 'T', '✕', '↑'],
        vw: 14.2857,
        value: ''
      },
      {
        name : 'リザルト',
        params: ['完登', '1テン', '2テン~', '落ち'],
        vw: 25,
        value: ''
      },
      {
        name : 'コメント',
        params: [],
        vw: 100,
        value: ''
      }
    ]
  }
]

// initial state
const state = () => ({
    selectedPlace : {}
  })

// getters
const getters = {
  getPlaceList: () => {
    const placeList: string[] = [];
    places.forEach(element => placeList.push(element.name));
    return placeList;
  },
  getCurrentPlace: (name: string) => {
    let currentPlace = '';
    places.forEach(element => {
      if (element.name === name ) {currentPlace = element.name} });
    return currentPlace;
  }
}
  
// mutations
const mutations = {
  setPlace (state: { selectedPlace: any}, inputPlaces: string) {
      state.selectedPlace = places.find((v) => v.name == inputPlaces)
      // console.log(state.selectedPlace.category.findIndex(({name}) => name === categoryName).name)
      // console.log(state.selectedPlace.category)
      // const index: number = state.selectedPlace.category.findIndex(({name}) => name === '壁')
      // console.log(state.selectedPlace.category[index].value)
  },
  // setValues (state: { selectedPlace: any}, inputPlaces: string, categoryName: string, categoryPrams: string) {
  //   console.log('setValues')
  //   state.selectedPlace = places.find((v) => v.name == inputPlaces)
  //   // state.selectedPlace.category.findIndex(({name}) => name === categoryName).name
  //   // const index: number = state.selectedPlace.category.findIndex(({name}) => name === categoryName)
  //   // state.selectedPlace.category[index].value = categoryPrams
  // }
}

const actions = {
  SET_PLACE ( context: any, inputPlaces: string) {
    context.commit('setPlace', inputPlaces);
  },
  // SET_VALUES ( context: any, inputPlaces: string, categoryName: string, categoryPrams: string ) {
  //   context.commit('setValues', inputPlaces, categoryName ,categoryPrams);
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}